export const global = (() => {
    let global;
    if (typeof window !== 'undefined')
        global = window;
    if (!global && typeof process !== 'undefined')
        global = process;
    return global;
})();
